exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contentful-team-member-name-js": () => import("./../../../src/pages/{contentfulTeamMember.name}.js" /* webpackChunkName: "component---src-pages-contentful-team-member-name-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

